import React from 'react'
import {
    useMyBest,
	useMyPlayers,
} from './data'
import PlayerName from './PlayerName'
import { FaCalendarTimes } from 'react-icons/fa'
import './awayplayers.css'

const AwayPlayers = () => {

    const best = useMyBest()
    const playerData = useMyPlayers()
    const { available } = best

	const players = Object.keys(available).filter(playerId => !available[playerId] && !playerData?.[playerId]?.isFillin)

	if (!players.length)
		return null

	return (
		<div className="awayplayers">
            <FaCalendarTimes className="roster-no" />
            {
                players.map(playerId => <PlayerName key={playerId} playerId={playerId} />)
            }
        </div>
    )
}

export default AwayPlayers
